'use strict';

const $sectionWearingSlide = document.querySelector('.section-wearing-slide');
if ($sectionWearingSlide) {
  let option = {
    type: 'loop',
    focus: 'left',
    fixedWidth: 'calc((100% / 3) - (3.6rem / (3 / 2)))',
    gap: '3.6rem',
    speed: 400,
    autoplay: 'playing',
    interval: 4000,
    arrows: true,
    pagination: false,
    drag: true,
    mediaQuery: 'max',
    breakpoints: {
      749: {
        destroy: true
      }
    }
  };
  new Splide($sectionWearingSlide, option).mount();
};